import { useMemo, forwardRef } from 'react'
import { User } from '../../lib/user'
import { Game, GameStatus, Actions } from './Game'
import { Settings } from '../../lib/settings'
import { GAME_MODE_UNLIMITED } from '../../constants/strings'
import { WordList } from '../../lib/words'
import { GameStats } from '../../lib/localStorage'

type Props = {
  list: WordList,
  puzzleId: string,
  seed: string,
  user: User,
  settings: Settings,
  actions: Actions,
  setIsStatsModalOpen: (isOpen: boolean) => void
  onGameStatusChange: (status: GameStatus) => void
  onUpdateStats: (stats: GameStats) => void
  onHint: () => void
  setResponsive: (isResponsive: boolean) => void
}

export const UnlimitedGame = forwardRef(({
  list,
  puzzleId,
  seed,
  user,
  settings,
  actions,
  setIsStatsModalOpen,
  onGameStatusChange,
  onUpdateStats,
  onHint,
  setResponsive
}: Props, ref) => {

  const solution = useMemo(
    () => list.getSolutionFromPuzzleId(puzzleId, seed),
    [puzzleId, seed, list])

  if (!solution) {
    throw new Error('puzzle not found')
  }

  return <Game
    key={puzzleId}
    ref={ref}
    isArchive={false}
    list={list}
    user={user}
    solution={solution}
    mode={GAME_MODE_UNLIMITED}
    settings={settings}
    actions={actions}
    setIsStatsModalOpen={setIsStatsModalOpen}
    onGameStatusChange={onGameStatusChange}
    onUpdateStats={onUpdateStats}
    onHint={onHint}
    setResponsive={setResponsive}
  />
})

